import type { Permission } from '@elutide/shared';
import { segmentsFor } from '@/components/nav';
import type { Segment } from '@/components/TopBar';

export interface PageChrome {
  sectionId: string;
  title: string;
  segments: readonly Segment[];
  activeSegment: string | undefined;
}

const TITLES: Readonly<Record<string, string>> = {
  '': 'Home',
  inbox: 'Action Inbox',
  orders: 'Orders',
  stock: 'Stock',
  legend: 'Legend',
  bench: 'Bench',
  customers: 'Customers',
  support: 'Support',
  finance: 'Finance',
  growth: 'Growth',
  settings: 'Settings',
};

/**
 * The top bar title and sub-nav come from the URL, so a deep link from Slack paints the
 * right chrome without the route having to remember to set it.
 */
export function chromeFor(pathname: string, permissions?: ReadonlySet<Permission>): PageChrome {
  const parts = pathname.split('/').filter(Boolean);
  const sectionId = parts[0] ?? '';
  const title = TITLES[sectionId] ?? 'Ops';
  const segments = segmentsFor(sectionId, permissions);

  let activeSegment: string | undefined;
  if (segments.length > 0) {
    // Longest matching href wins, so /stock/inbound/:id still highlights Inbound.
    const match = [...segments]
      .sort((a, b) => b.href.length - a.href.length)
      .find((segment) => pathname === segment.href || pathname.startsWith(`${segment.href}/`));
    activeSegment = match?.id ?? segments[0]?.id;
  }

  return { sectionId, title, segments, activeSegment };
}
